import { IAtClickableProps } from '@/components/atoms';
import { ETagVariants } from '@/components/atoms/at-tag/at-tag.types';
import {
  EClickableSize,
  EClickableTarget,
  EClickableVariants,
} from '@/components/atoms/at-clickable/at-clickable.types';
import { EIcons } from '@/components/atoms/at-icon/icons';
import { EThemes } from '@/lib/contentstack-sdk/types';
import { IMlCardProps, EMlCardsTypes } from './ml-card.types';
import { EAlignment } from '../ml-header/ml-header.types';

export const mlCardInfographicMockData: IMlCardProps = {
  title: 'Move walls, add rooms',
  body: 'Modify floor plans to suit your lifestyle: expand living areas, add bedrooms, or create custom spaces like nooks, home offices or in-law suites.',
  iconName: EIcons.HAMMER,
};

export const mlCardLinkMockData: IAtClickableProps = {
  children: 'Read More',
  target: EClickableTarget.SELF,
  href: '#',
  variant: EClickableVariants.PRIMARY,
  interactLocation: 'test',
};

export const mlCardImageMockData: IMlCardProps = {
  variant: EMlCardsTypes.IMAGE,
  alignment: EAlignment.CENTER,
  title: 'Personalize your home preferences',
  body: 'Customize every detail to reflect your unique style and needs',
  imageProps: {
    src: {
      mobile: '/assets/image_card.jpg',
      tablet: '/assets/image_card.jpg',
      desktop: '/assets/image_card.jpg',
    },
    alt: 'test image',
  },
};

export const mlCardHomePlanMockData: IMlCardProps = {
  variant: EMlCardsTypes.HOME_PLAN,
  homePlanProps: {
    id: 1,
    name: 'Olivia',
    description: 'Modern Farmhouse',
    features: ['3 BED', '2 BATH', '1450 SQ.FT', '$415,000'],
    tags: [
      {
        variant: ETagVariants.FEATURED,
        children: '+ Model Tour',
        size: EClickableSize.LG,
      },
      {
        variant: ETagVariants.DEFAULT,
        children: '5 Exteriors',
        size: EClickableSize.LG,
      },
    ],
  },
  imageProps: {
    src: {
      mobile: '/assets/home_plan.jpeg',
      tablet: '/assets/home_plan.jpeg',
      desktop: '/assets/home_plan.jpeg',
    },
    alt: 'home plan test',
  },
};

export const mlCardIconMockData: IMlCardProps = {
  title: 'Take a tour & set your price',
  body: 'Visiting a Design Center and touring a Model Home is a perfect way to get hands-on insight, and a price that fits your budget!',
  variant: EMlCardsTypes.ICON,
  alignment: 'center',
  theme: EThemes.DARK,
  iconName: EIcons.DOOR,
  ctaProps: {
    interactLocation: 'test',
    children: 'Schedule a Meeting',
    variant: EClickableVariants.PRIMARY,
  },
};
